<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="#">VIP会员申请</a></li>
            </ul>
        </div>

        <div id="usual1" class="usual">
            <div class="formbody">
                <div class="formtitle"><span>VIP会员申请</span></div>
                <ul class="forminfo">
                    <li>
                        <label style="width:100px;">个人名称<b>*</b></label>
                        <input type="text" class="dfinput left maringht10" v-model="companyname"/>
                        <label v-if="status==0">未审核</label><label style="color:green;" v-else-if="status==1">审核通过</label><label style="color:red;" v-else>审核不通过</label>
                    </li>
                    <li>
                        <label style="width:100px;">业务类型<b>*</b></label>
                        <div class="vocation">
                            <el-select v-model="gnclass" placeholder="请选择">
                                <el-option
                                    v-for="item in gnclassList"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="year" placeholder="请选择">
                                <el-option
                                    v-for="item in yearList"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </li>
                    <li>
                        <label style="width:100px;">公司地址<b>*</b></label>
                        <input type="text" class="dfinput left maringht10" v-model="companyaddress"/>
                    </li>
                    <!-- <li>
                        <label style="width:100px;">联系人<b>*</b></label>
                        <input type="text" class="dfinput left maringht10" v-model="contact"/>
                    </li> -->
                    <li>
                        <label style="width:100px;">手机号<b>*</b></label>
                        <input type="text" class="dfinput left maringht10" v-model="phonenum"/>
                        <!-- <i class="toolbars lh33">填写固定电话</i> -->
                    </li>
                    <li>
                        <label style="width:100px;">类型<b>*</b></label>
                        <el-radio v-model="type" label="个人" @change="checktype('个人')">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px;">个人</label>
                        </el-radio>
                        <el-radio v-model="type" label="企业" @change="checktype('企业')">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px;">企业</label>
                        </el-radio>
                    </li>
                    <li v-show="geren">
                        <label style="width:100px;">身份证复印件<b>*</b></label>
                        <div class="buttonupload  click" v-if="personID.length > 1"> 已经上传 </div>
                        <input v-if="personID.length > 1" class="sure" type="button" @click="delfile('personID')"  value="删除文件">
                        <div  v-if="personID.length < 1"> 
                            <el-upload
                                class="upload-demo"
                                :on-success="uploadSuccess"
                                :action=uploadUserVipImgUrl1
                                :accept="'image/*'" 
                                :show-file-list="false"
                                :headers="uploadHeaders"
                                :on-change="handleChange">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </li>
                    <li v-show="qiye">
                        <label style="width:100px;">营业执照复印件<b>*</b></label>
                        <div class="buttonupload  click" v-if="companycode.length > 1"> 已经上传 </div>
                        <input v-if="companycode.length > 1" class="sure" type="button" @click="delfile('companycode')"  value="删除文件">
                        <div  v-if="companycode.length < 1"> 
                            <el-upload
                                class="upload-demo"
                                :on-success="uploadSuccess"
                                :action=uploadUserVipImgUrl2
                                :accept="'image/*'" 
                                :show-file-list="false"
                                :headers="uploadHeaders"
                                :on-change="handleChange">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </li>
                    <!-- <li v-show="qiye">
                        <label style="width:100px;">银行开户证明<b>*</b></label>
                        <div class="buttonupload  click" v-if="bankcode.length > 1"> 已经上传 </div>
                        <input v-if="bankcode.length > 1" class="sure" type="button" @click="delfile('bankcode')"  value="删除文件">
                        <div  v-if="bankcode.length < 1"> 
                            <el-upload
                                class="upload-demo"
                                :on-success="uploadSuccess"
                                :action=uploadUserVipImgUrl3
                                :accept="'image/*'" 
                                :show-file-list="false"
                                :headers="uploadHeaders"
                                :on-change="handleChange">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </li> -->
                    <li>
                        <label style="width:100px;">短信签名<b>*</b></label>
                        <input v-model="sign" type="text" class="dfinput left maringht10" />
                        <i class="toolbars lh33">建议2-8字中文，系统会自动在相关短信末尾加：【您的签名】；签名算入短信计费字数 </i>
                    </li>
                    <li>
                        <label style="width:100px;">申请说明</label>
                        <textarea v-model="msg" cols="" rows="" class="textinput left maringht10"></textarea>
                    </li>
                    <li>
                        <label>&nbsp;</label>
                        <input type="button" class="btn" style="margin-left:14px;" value="保存并提交申请" @click="updUserVipInfo()"/>
                    </li>
                </ul>
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                    <b>注意</b>
                </div>
                <ul class="infolist">  
                    <li>1、内容限自用、通知类服务，不允许发送广告,更不允许代发，短信通道限制见通道描述；违规罚没保证金  </li> 
                    <li>2、申请用户注册半年以上，累计消费1000元以上，无不良记录，不允许虚报内容类型; </li>
                    <li>3、预付保证金个人200元，企业300元，有投诉或非法内容则罚没，非自用而发送第三方类容加倍收取费用并罚没保证金；</li>
                    <li>4、保证提交证件的真实性。签名尽量不宜设置太长，需包含企业品牌</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            id:0,
            companyname: '',
            companyaddress: '',
            contact: '',
            phonenum: '',
            type: '个人',
            personID: '',
            companycode: '',
            bankcode: '',
            sign: '',
            msg: '',
            gnclass: '1',
            gnclassList: [
                {text:'120元/年  优惠率10%', value:'1'}
            ],
            year:1,
            yearList:[
                {text:'1年',value:1}
            ],
            geren: true,
            qiye: false,
            uploadUserVipImgUrl1: this.GLOBAL.serverSrc + "/person/uploaduservipimg.json?typeCode=personID",
            uploadUserVipImgUrl2: this.GLOBAL.serverSrc + "/person/uploaduservipimg.json?typeCode=companycode",
            uploadUserVipImgUrl3: this.GLOBAL.serverSrc + "/person/uploaduservipimg.json?typeCode=bankcode",
            uploadHeaders: {},
            fileUploadParams:{'typeCode':'personID'},
            status:0,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        // this.checktype('个人')
        this.uploadHeaders.token = this.GLOBAL.token
        this.getUserVipInfo()
    },
    methods: {
        handleChange(file, fileList) {
        },
        uploadSuccess(response){
            if (response.code === '0000000') {
                this.$message({
                    type: 'success',
                    message: "证件上传成功！",
                });
                if(response.type == 'personID'){
                    this.personID = response.filePath;
                }
                else if(response.typeCode == 'companycode'){
                    this.companycode = response.filePath;
                }
                else if(response.typeCode == 'bankcode'){
                    this.bankcode = response.filePath;
                }
                //this.getUserVipInfo();
            }
            else if("0000006" == response.code){
                this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是gif，jpg，png格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                // console.log(JSON.stringify(response.data))
            }
        },
        submitUpload1(typeCode){
            this.uploadHeaders.token = this.GLOBAL.token;
            this.fileUploadParams.typeCode = 'personID';
            this.$refs.upload.submit();
        },
        submitUpload2(typeCode){
            this.uploadHeaders.token = this.GLOBAL.token;
            this.fileUploadParams.typeCode = 'companycode';
            this.$refs.upload.submit();
        },
        submitUpload3(typeCode){
            this.uploadHeaders.token = this.GLOBAL.token;
            this.fileUploadParams.typeCode = 'bankcode';
            this.$refs.upload.submit();
        },
        getUserVipInfo() {
            var that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/getuservipinfo.json",
                data: data,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.id = res.data.id;
                    that.companyname = res.data.companyname == null ? "" : res.data.companyname
                    that.companyaddress = res.data.companyaddress == null ? "" : res.data.companyaddress
                    that.contact = res.data.contact == null ? "" : res.data.contact
                    that.gnclass = res.data.gnclass == null ? "" : res.data.gnclass
                    that.phonenum = res.data.phonenum == null ? "" : res.data.phonenum
                    that.type = res.data.type == null ? "" : res.data.type
                    that.personID = res.data.personID == undefined ? "" : res.data.personID
                    that.companycode = res.data.companycode == undefined ? "" : res.data.companycode
                    that.bankcode = res.data.bankcode == undefined ? "" : res.data.bankcode
                    that.sign = res.data.sign == null ? "" : res.data.sign
                    that.msg = res.data.msg2 == null ? "" : res.data.msg2;
                    that.status = res.data.status;
                    if(that.type == "")
                    {
                        that.checktype('个人')
                    }
                    else
                    {
                        that.checktype(that.type)
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        checktype(type) {
            if(type == "个人")
            {
                // this.geren = true
                this.qiye = false
                this.type = '个人'
            }
            else if(type == "企业")
            {
                // this.geren = true
                this.qiye = true
                this.type = '企业'
            }
        },
        delfile(filetype) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let that = this
                    let data = {'id':this.id, 'typeCode':filetype}
                    this.$ajax({
                        method: 'post',
                        url: this.GLOBAL.serverSrc + '/person/deluservipfile.json',
                        data: data,
                        headers: {
                            'Content-Type': 'application/json; charset=UTF-8',
                            'token' : this.GLOBAL.token
                        }
                    }).then(function(res) {
                        if('0000000' == res.data.code)
                        {
                            that.$message({
                                type: 'success',
                                message: "删除成功！",
                            });
                            that.getUserVipInfo();
                        }
                        else
                        {
                            that.$message({
                                type: 'error',
                                message: res.data.msg,
                            });
                        }
                    })
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        updUserVipInfo() {
            if(this.companyname.trim().length < 1)
            {
                this.$alert('个人名称不能为空!')
                return false;
            }
            if(this.gnclass == '')
            {
                this.$alert('请选择业务类型!')
                return false;
            }
            if(this.companyaddress.trim().length < 1)
            {
                this.$alert("公司地址不能为空!")
                return false;
            }
            // if(this.contact.trim().length < 1)
            // {
            //     this.$alert("请输入联系人姓名!")
            //     return false;
            // }
            if(this.phonenum.trim().length < 1)
            {
                this.$alert("手机号不能为空")
                return false;
            }
            if(this.phonenum.trim().length != 11)
            {
                this.$alert("请输入11位有效手机号")
                return false;
            }
            if(this.type == '个人')
            {
                if(this.personID.trim().length <　1)
                {
                    this.$alert("请上传身份证复印件")
                    return false;
                }
            }
            else if(this.type == '企业')
            {
                if(this.personID.trim().length <　1)
                {
                    this.$alert("请上传身份证复印件")
                    return false;
                }
                if(this.companycode.trim().length <　1)
                {
                    this.$alert("请上传营业执照复印件")
                    return false;
                }
                // if(this.bankcode.trim().length <　1)
                // {
                //     this.$alert("请上传银行开户证明复印件")
                //     return false;
                // }
            }
            var that = this
            let param = {'id':this.id,'companyname': this.companyname, 'gnclass': this.gnclass, 'companyaddress': this.companyaddress, 'contact': this.contact, 'phonenum': this.phonenum,
                'type': this.type, 'personID': this.personID, 'companycode': this.companycode, 'bankcode': this.bankcode, 'sign': this.sign, 'msg': this.msg}
            // alert(JSON.stringify(param))
            // return false;
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/upduservipinfo.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if("0000000" == res.data.code)
                {
                    that.$message({
                        type: 'success',
                        message: "VIP申请成功！",
                    });
                    that.getUserVipInfo();
                }
                else
                {
                    this.$alert(res.data.msg)
                    return false
                }
            })
        }
    }
}
</script>>



// WEBPACK FOOTER //
// src/components/person/uservip.vue